<template>
  <div class="app-container">
    <Navbar />
    <main class="content">
      <section id="hero"><Hero /></section>
      <section id="about"><About /></section>
      <section id="mission-vision"><MissionVision /></section>
      <section id="products"><Products /></section>
      <section id="services"><Services /></section>
      <section id="partners"><Partners /></section>
      <section id="contact-us"><ContactUs /></section>
    </main>
    <Footer />
    
    <ScrollTop />
  </div>
</template>

<script setup>
import Navbar from './components/Navbar.vue';
import Footer from './components/Footer.vue';
import Hero from './components/Hero.vue';
import About from './components/About.vue';
import MissionVision from './components/MissionVision.vue';
import Products from './components/Products.vue';
import Services from './components/Services.vue';
import Partners from './components/Partners.vue';
import ContactUs from './components/ContactUs.vue';
import ScrollTop from './components/ScrollTop.vue';
</script>
